import React from "react";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const DropdownMultipleValue = ({
  options,
  placeholder = null,
  inputRef,
  value,
  onChange,
  selectStyle,
  optionStyle,
  is_error = false,
  isMulti = false,
  createAble = false,
  handleOnCloseDropdown = null,
  handleOnOpenDropdown = null,
}) => {
  if (createAble) {
    return (
      <CreatableSelect
        ref={inputRef}
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        isClearable={value.some((v) => !v.isFixed)}
        styles={{
          control: (provided, state) => ({
            ...provided,
            ...selectStyle,
            ":hover": {
              border: `3px solid ${is_error ? "#EB4335" : "00bb99"}`,
              color: "white",
              borderRadius: "10px",
              overflow: "visible",
            },
          }),
          option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
              ...styles,
              ...optionStyle,
              cursor: isDisabled ? "not-allowed" : "default",
            };
          },
          multiValue: (styles, { data }) => {
            return {
              ...styles,
              backgroundColor: "#00bb99",
              borderRadius: "20px",
              color: "#FFFFFF",
              padding: "2.5px",
            };
          },
          multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: data.color,
          }),
          multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: "white",
            ":hover": {
              backgroundColor: "#00bb99",
              color: "white",
              borderRadius: "20px",
            },
          }),
        }}
      />
    );
  } else {
    return (
      <Select
        ref={inputRef}
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        styles={{
          control: (provided, state) => ({
            ...provided,
            ...selectStyle,
          }),
          option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
              ...styles,
              ...optionStyle,
              cursor: isDisabled ? "not-allowed" : "default",
            };
          },
        }}
        onMenuOpen={handleOnOpenDropdown}
        onMenuClose={handleOnCloseDropdown}
      />
    );
  }
};

export default DropdownMultipleValue;
